import React, { memo } from 'react';
import { ButtonBase } from '@mui/material';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';

import palette from '../styles/palette';

const useStyles = makeStyles(() => ({
  button: {
    color: palette.typography.white.solid,
    fontSize: '0.688rem',
    lineHeight: '0.813rem',
    padding: '0.125rem 0.25rem',
    border: '0.063rem solid white',
    borderRadius: '0.313rem',
    margin: '0.625rem 0.875rem 0 0',
    letterSpacing: '0.0025em',
    cursor: 'pointer',
    fontFamily: 'Roboto',
  },
  buttonActive: {
    color: palette.typography.black.high,
    background: palette.typography.white.solid,
  },
}));

const FilterItemButton = ({ children, active, onClick }) => {
  const styles = useStyles();

  return (
    <ButtonBase
      className={clsx(styles.button, active && styles.buttonActive)}
      onClick={onClick}
    >
      {children}
    </ButtonBase>
  );
};

export default memo(FilterItemButton);
